import React from 'react';
import { iframeService, isMobile } from '@pascal/pascal-core';
import { AdditionalInputValueChangingButtons } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';

const BetInput = ({
  onBlur,
  // limits,
  onChange,
  betAmount,
  showNotification,
  handleOpenNumPad,
  setIsValidatedAmount,
  handleChangeInputValue,
}) => {
  // const isDisablePlusButton = +betAmount === +limits.maxBet ? 'passive' : '';
  // const isDisabledMinusButton = +betAmount <= +limits.minBet ? 'passive' : '';
  return (
    <div className='b-s-input-ins'>
      <div className='b-s-input-block'>
        <div
          className='b-s-input-icon left'
          onClick={() => {
            // decidedCallBackCall(
            //   () => changeBetAmount(additionalBetAmountChangingButtons.minus),
            //   true
            // );
            handleChangeInputValue(AdditionalInputValueChangingButtons.minus);
          }}
        >
          <i className='ui-lib-minus' />
        </div>
        <input
          type='text'
          maxLength={9}
          readOnly={isMobile()}
          inputMode={isMobile() ? 'none' : 'text'}
          // disabled={isDisabled}
          autoComplete='off'
          title={`${betAmount || ''}`}
          className='b-s-input'
          value={betAmount || ''}
          onBlur={() => {
            const { validatedBetAmount, errorMessageCode } = onBlur(betAmount);
            if (errorMessageCode) {
              showNotification({ responseCode: errorMessageCode });
              setIsValidatedAmount(true);
              setTimeout(() => setIsValidatedAmount(false), 200);
            }
            iframeService.sendStakeUpdate(validatedBetAmount);
            onChange(validatedBetAmount);
          }}
          onChange={(e) => {
            if (!/^[.,]/.test(e.target.value) && /^\d*[.,]?\d*$/.test(e.target.value)) {
              onChange(e.target.value.replace(',', '.'));
            }
          }}
          {...(isMobile() ? { onClick: (e) => handleOpenNumPad(e) } : {})}
        />
        <div
          className='b-s-input-icon right'
          onClick={() => {
            handleChangeInputValue(AdditionalInputValueChangingButtons.plus);
            // decidedCallBackCall(
            //   () => changeBetAmount(additionalBetAmountChangingButtons.plus),
            //   true
            // );
          }}
        >
          <i className='ui-lib-plus' />
        </div>
      </div>
    </div>
  );
};

export default BetInput;
